import React from 'react';
import profilePic from '../assets/mgbn.jpg';

function Home({ scrollToSection }) {
  const goToContact = (event) => {
    event.preventDefault();
    scrollToSection('contact');
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-grid">
          <div>
            <h1>Müge Tüfekçi</h1>
            <p className="hero-role">Uzman Psikolog</p>
            <p className="hero-location">Alsancak - İzmir</p>
            <div className="actions">
              <a className="button primary" href="#contact" onClick={goToContact}>
                İletişime Geç
              </a>
            </div>
          </div>
          <div>
            <img
              className="portrait"
              src={profilePic}
              loading="eager"
              fetchPriority="high"
              decoding="async"
              alt="Uzman Psikolog Müge Tüfekçi portresi"
            />
            <div className="actions mobile-actions">
              <a className="button primary" href="#contact" onClick={goToContact}>
                İletişime Geç
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
